import { render, staticRenderFns } from "./UserDashboards.vue?vue&type=template&id=54dae2e7"
import script from "./UserDashboards.vue?vue&type=script&lang=ts"
export * from "./UserDashboards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports